import TYPES from '../actions/types';

const INITIAL_STATE = {
    list: [],
    paging: {},
    filter: {},
    selected: null,
    degrees: {
        titulaciones: [],
        diplomas_tipos: []
    }
};

export const studentReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case TYPES.SET_STUDENTS:
            const { count, current, page, pageCount, sort, direction } = action.payload.paging;
            return {
                ...state, 
                list: action.payload.list, 
                paging: { count, current, page, pageCount, sort, direction }
            };

        case TYPES.SELECT_STUDENT:
            return {
                ...state,
                selected: action.payload
            };

        case TYPES.SET_STUDENT_FILTER:
            return {
                ...state,
                filter: action.payload,
                paging: {}
            };

        case TYPES.SET_STUDENT_TITULACIONES:
            return {
                ...state,
                degrees: action.payload
            };
        
        default:
            return state;
    }

};